import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import LoaderComponent from "../../Common/LoaderComponent";
import useRequiredFields from "../../../hooks/useRequiredFields";
import IsLogin from "../../Common/IsLogin";
import Http from "../../Common/Http";
import Image from "../../Common/Image";

const Edit = () => {
    const navigate = useNavigate();
    const [inputs, setInputs] = useState({});
    const [error, setError] = useState({});
    const [totalAmount, setTotalAmount] = useState(0);
    const [list, setList] = useState([{ purpose: "", amount: "" }]);
    const { checkRequiredFields } = useRequiredFields();
    const [selectedImage, setSelectedImage] = useState(null);

    const { id } = useParams();
    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setInputs((values) => ({ ...values, [name]: value }));
    }
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const inputInfo = [...list];
        inputInfo[index][name] = value;
        setList(inputInfo);
    }

    const displayError = (fieldName) => {
        if (error && error[fieldName]) {
            return <div className="text-danger small">{error[fieldName]}</div>;
        }
        return null;
    }

    useEffect(() => {
        Http.get("/gless-colour-edit/" + id).then((res) => {
            setInputs(res.data);
        })
    }, [id])

    const formSubmit = (e) => {
        e.preventDefault();
        const { isValid, error } = checkRequiredFields(inputs);
        if (!isValid) {
             setError(error);
        }
       
        Http.put("/gless-colour-update/" + id, inputs).then((res) => {
            Swal.fire({
                title: 'Success',
                text: 'Gless Colour created successfully',
                icon: 'success'
            }).then(() => {
                navigate('/gless-colour');
            })
        })
  
    }

    const handleImageChange = (e) => {
      return  setSelectedImage(e.target.files[0]);
    }
  
    return (
        <>
            <IsLogin />
            <LoaderComponent />
            <div className="am-mainpanel">
                <div className="am-pagetitle g-2">
                <h5 className="am-title">Glaze Colour</h5>
                    <Link to="/gless-colour" className="btn btn-primary">
                        <i className="fa fa-bars mg-r-6"></i>
                        list
                    </Link>
                </div>
                <div className="am-pagebody">
                    <div className="card pd-20 pd-sm-40">
                        <div className="table-wrapper">
                            <form onSubmit={formSubmit}>
                                <div className="form-group">
                                    <label htmlFor="code">Colour Name</label>
                                    <input type="text" className="form-control" name="colour_name" onChange={handleChange} value={inputs.colour_name} />
                                </div>
                                <button type="submit" className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Edit;